import {useSelector} from 'lib/redux'
import React, {useMemo} from 'react'
import {FirebaseMessageListItem, MessageMode, ObjectState} from 'types'
import {useFirebaseMessageRoom, useFirebaseMessageRoomMember} from 'utils'
import GiftShopMessageListItemForkygram from './GiftShopMessageListItemForkygram'
import GiftShopMessageListItemGiftshop from './GiftShopMessageListItemGiftshop'
import GiftShopMessageListItemSystem from './GiftShopMessageListItemSystem'

export interface GiftShopMessageListItemProps {
  data: FirebaseMessageListItem
  search: string
  stateSelectedMessagesForkygram: ObjectState<string[]>
  stateSelectedMessagesGS: ObjectState<string[]>
  stateSelectedMessagesSystem: ObjectState<string[]>
  mode: MessageMode
}

export default function GiftShopMessageListItem({
  data,
  search,
  stateSelectedMessagesForkygram,
  stateSelectedMessagesGS,
  stateSelectedMessagesSystem,
  mode,
}: GiftShopMessageListItemProps) {
  const {last_update, last_enter, last_deleted_at} = data
  const messageRoomState = Object.values(useSelector('messageRoomState'))
  const last_leave =
    messageRoomState.find((elem) => elem.room_id === data.room_id)
      ?.last_leave || undefined
  const time = Math.max(
    last_enter ? new Date(last_enter).getTime() : 0,
    last_leave ? new Date(last_leave).getTime() : 0,
  )
  const hasNewMessage = time < new Date(last_update).getTime()

  const {members} = useFirebaseMessageRoomMember({
    roomId: data.room_id,
    roomType: data.room_type,
  })
  const {messages} = useFirebaseMessageRoom({
    roomId: data.room_id,
    roomType: data.room_type,
    limit: 1,
    sort: 'desc',
  })

  const message = useMemo(() => (messages.length ? messages[0] : undefined), [
    messages,
  ])
  const selectedMessage = stateSelectedMessagesForkygram[0]
  const selectedMessageGS = stateSelectedMessagesGS[0]
  const selectedMessageSystem = stateSelectedMessagesSystem[0]
  if ((!!last_deleted_at && last_deleted_at > last_update) || !message) {
    return null
  }

  switch (data.room_type) {
    case 'chat':
      return (
        <GiftShopMessageListItemForkygram
          roomId={data.room_id}
          roomType={data.room_type}
          members={members}
          messages={message}
          hasNewMessage={hasNewMessage}
          search={search}
          stateSelectedMessages={stateSelectedMessagesForkygram}
          mode={mode}
          isSelected={selectedMessage.some((x) => x === data.room_id)}
        />
      )
    case 'giftshop':
      return (
        <GiftShopMessageListItemGiftshop
          roomId={data.room_id}
          roomType={data.room_type}
          members={members}
          messages={message}
          hasNewMessage={hasNewMessage}
          search={search}
          stateSelectedMessages={stateSelectedMessagesGS}
          mode={mode}
          isSelected={selectedMessageGS.some((x) => x === data.room_id)}
        />
      )
    case 'system':
      return (
        <GiftShopMessageListItemSystem
          roomId={data.room_id}
          roomType={data.room_type}
          members={members}
          messages={message}
          hasNewMessage={hasNewMessage}
          search={search}
          mode={mode}
          stateSelectedMessages={stateSelectedMessagesSystem}
          isSelected={selectedMessageSystem.some((x) => x === data.room_id)}
        />
      )
    default:
      return null
  }
}
